module.exports = __webpack_public_path__ + "static/media/goldPilePreview.62b83b2c.png";